"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

var Batcher, Events, parser;
parser = require("./parser");
Events = require("./Events");

Batcher = function () {
  var Batcher = /*#__PURE__*/function () {
    function Batcher() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Batcher);

      this.options = options;
      parser.load(this.options, this.defaults, this);
      this.Events = new Events(this);
      this._arr = [];

      this._resetPromise();

      this._lastFlush = Date.now();
    }

    _createClass(Batcher, [{
      key: "_resetPromise",
      value: function _resetPromise() {
        var _this = this;

        return this._promise = new this.Promise(function (res, rej) {
          return _this._resolve = res;
        });
      }
    }, {
      key: "_flush",
      value: function _flush() {
        clearTimeout(this._timeout);
        this._lastFlush = Date.now();

        this._resolve();

        this.Events.trigger("batch", this._arr);
        this._arr = [];
        return this._resetPromise();
      }
    }, {
      key: "add",
      value: function add(data) {
        var _this2 = this;

        var ret;

        this._arr.push(data);

        ret = this._promise;

        if (this._arr.length === this.maxSize) {
          this._flush();
        } else if (this.maxTime != null && this._arr.length === 1) {
          this._timeout = setTimeout(function () {
            return _this2._flush();
          }, this.maxTime);
        }

        return ret;
      }
    }]);

    return Batcher;
  }();

  ;
  Batcher.prototype.defaults = {
    maxTime: null,
    maxSize: null,
    Promise: Promise
  };
  return Batcher;
}.call(void 0);

module.exports = Batcher;